module.exports = __webpack_public_path__ + "img/down2-zh.bbf8bef7.png";